import * as React from 'react';

interface IProps {
  isDetail: boolean;
  color: string;
  colorBoundaryValue: number;
  zIndex: number;
  height: string;
  colorBoundaries: number[];
  detailValues?: boolean;
}

export default function DynamicLeftAxisPart(props: IProps) {
  const [arrayValues, setArrayValues] = React.useState<number[]>([]);

  const getArray = (arr: number[]) => {
    const arrayValue = arr[arr.length - 1];
    if (arrayValue - 10 > 0 && arrayValue - 10 > props.colorBoundaries[props.zIndex + 1]) {
      arr.push(arrayValue - 10);
      getArray(arr);
    }
    return arr;
  };

  const getArrayValues = () => {
    if (props.colorBoundaryValue > 10) {
      const result = getArray([props.colorBoundaryValue - (props.colorBoundaryValue % 10)]);
      if (result.length > 0) {
        setArrayValues(result);
      }
    }
  };

  const getLeftValue = (value: number) => {
    if (String(value).length > 2) {
      return '-12px';
    }
    if (String(value).length === 2) {
      return '-8px';
    }
    return '0';
  };

  React.useEffect(() => {
    if (props.detailValues && arrayValues.length === 0) {
      getArrayValues();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.detailValues, props.colorBoundaryValue]);

  return (
    <div
      style={{
        zIndex: props.zIndex,
        position: 'absolute',
        left: '9px',
        width: '1px',
        height: props.isDetail ? '378px' : '169px',
        background: 'transparent',
      }}
    >
      <div
        style={{
          position: 'absolute',
          width: '1px',
          height: props.height,
          background: props.color,
          bottom: 0,
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: props.isDetail ? '-8px' : '-7px',
            left: '-13px',
            color: props.color,
          }}
        >
          <div
            style={{
              left: getLeftValue(props.colorBoundaryValue),
              position: 'absolute',
              top: '-2px',
            }}
          >
            {props.colorBoundaryValue}
          </div>
          <div
            style={{
              position: 'absolute',
              top: '7px',
              left: '14px',
              borderBottom: `1px solid ${props.color}`,
              width: '12px',
            }}
          />
        </div>

        {arrayValues.length > 0 &&
          arrayValues.map((value) => {
            return (
              <div
                style={{
                  position: 'absolute',
                  top: `calc(${(1 - value / props.colorBoundaryValue) * 100}% - ${
                    props.isDetail ? '8px' : '7px'
                  })`,

                  left: '-13px',
                  color: props.color,
                }}
              >
                {' '}
                <div style={{ left: getLeftValue(value), position: 'absolute', top: '-2px' }}>
                  {value}
                </div>
                <div
                  style={{
                    position: 'absolute',
                    top: '7px',
                    left: '14px',
                    borderBottom: `1px solid ${props.color}`,
                    width: '12px',
                  }}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
}
